require('./bootstrap');

export const initTripRegistrationListeners = function () {

    $('.program').change(function (el) {
        $('.programTrips').hide();
        $('.programTrip').prop('checked', false);

        $('#primary_date_select').find('option').remove().end().append('<option>Select Date...</option>');
        $('#primary_date_select').prop('selectedIndex', 0);

        $('#secondary_date_select').find('option').remove().end().append('<option>Select Date...</option>');
        $('#secondary_date_select').prop('selectedIndex', 0);
        if ($('.program:checked')) {
            var checked = $('.program:checked').val();
            $('#program_' + checked).css("display", "inherit");
        }
    });

    $('#billingSameMailing').on('click', function (el) {
        var target = $(el.target);
        if (target[0].value == '1') {
            target[0].value = '0';
            $('#billingAddressFields').show();
        } else if (target[0].value == '0') {
            target[0].value = '1';
            $('#billingAddressFields').hide();
        }
    });

    $('.participatedBefore').change(function (el) {
        var target = $(el.target);

        if (target[0].value == '1') {
            $('.participated').show();
        }
        if (target[0].value == '0') {
            $('.participated').hide();
        }
    });

    $('.memberPairing').on('click', function (el) {
        var target = $(el.target);

        if (target[0].value == '0') {
            target[0].value = '1';
            $('#pairing_input').show();
        } else if (target[0].value == '1') {
            target[0].value = '0';
            $('#pairing_input').hide();
        }
    });

    $('.hospital').change(function (el) {
        var target = $(el.target);
        if (target[0].value == '1') {
            $('#hospital_description').show();
        }
        if (target[0].value == '0') {
            $('#hospital_description').hide();
        }
    });

    $('.coldInjury').change(function (el) {
        var target = $(el.target);

        if (target[0].value == '1') {
            $('#cold_injury_description').show();
        }
        if (target[0].value == '0') {
            $('#cold_injury_description').hide();
        }
    });

    $('.altitudeIllness').change(function (el) {
        var target = $(el.target);

        if (target[0].value == '1') {
            $('#altitude_illness_description').show();
        }
        if (target[0].value == '0') {
            $('#altitude_illness_description').hide();
        }
    });

    $('.smoker').change(function (el) {
        var target = $(el.target);

        if (target[0].value == '1') {
            $('#smoker_description').show();
        }
        if (target[0].value == '0') {
            $('#smoker_description').hide();
        }
    });

    $('.preexisting').change(function (el) {
        var target = $(el.target);

        if (target[0].value == '1') {
            $('#preexisting_conditions_description').show();
        }
        if (target[0].value == '0') {
            $('#preexisting_conditions_description').hide();
        }
    });
    
    //Shows or hides parent/guardian signature fields
    $('#DOB').change(function (event) {
        let DOB = new Date(event.target.value + "T12:00:00");
        let diff = Date.now() - DOB;
        let ageDiff = new Date(diff);

        if (Math.abs(ageDiff.getUTCFullYear() - 1970) < 18) {
            $('#isMinor').val('1');
            $('#additional-indemnification').removeClass('hide')
            $('.add-indem-input').each(function () {
                $(this).removeAttr('disabled')
            });
        } else {

            $('#isMinor').val('0');
            $('#additional-indemnification').addClass('hide');
            $('.add-indem-input').each(function () {
                $(this).attr('disabled', true)
            });
        }

    });


}